import React from 'react';
import styles from '../styles/SellerBadge.module.css';

// Distingue un anuncio publicado por un vendedor tercero de un chollo propio
// de Esganga. deal.store ya lleva el nombre de la tienda del vendedor (se
// reutiliza store_name al crear el anuncio), asi que solo hace falta marcar
// visualmente el origen.
const SellerBadge = ({ listingOrigin, className }) => {
    if (listingOrigin !== 'seller') {
        return null;
    }

    return <span className={`${styles.badge} ${className || ''}`}>Anuncio</span>;
};

export default SellerBadge;
